import { render, staticRenderFns } from "./UserPersonalCardAdd.vue?vue&type=template&id=959cf8c0&"
import script from "./UserPersonalCardAdd.vue?vue&type=script&lang=js&"
export * from "./UserPersonalCardAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports